import React from 'react';

interface SettingsCardProps {
  title: React.ReactNode;
  extra?: React.ReactNode;
  children: React.ReactNode;
  /** scroll the body internally instead of growing */
  scroll?: boolean;
  /** remove body padding (e.g. for full-bleed tables) */
  pad0?: boolean;
  /** footer row (e.g. an EditSaveFooter) */
  footer?: React.ReactNode;
  /** validation messages shown in red above the footer */
  errors?: string[];
  className?: string;
  style?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
}

/** A titled card matching the Analysis Studio command-center look. */
const SettingsCard: React.FC<SettingsCardProps> = ({
  title,
  extra,
  children,
  scroll,
  pad0,
  footer,
  errors,
  className,
  style,
  bodyStyle,
}) => {
  const bodyClass = [
    'set-studio__card-body',
    scroll ? 'set-studio__card-body--scroll' : '',
    pad0 ? 'set-studio__card-body--pad0' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={['set-studio__card', className].filter(Boolean).join(' ')}
      style={style}
    >
      <div className="set-studio__card-head">
        <span className="set-studio__card-title">{title}</span>
        {extra ? <span className="set-studio__card-extra">{extra}</span> : null}
      </div>
      <div className={bodyClass} style={bodyStyle}>
        {children}
      </div>
      {errors && errors.length > 0 ? (
        <div className="set-studio__errors">{errors.join(' ')}</div>
      ) : null}
      {footer ? <div className="set-studio__cardfoot">{footer}</div> : null}
    </div>
  );
};

export default SettingsCard;
